import { create } from 'zustand';

interface OpenOptions {
  /**
   * World-space point where a newly created/opened entity should be placed.
   * Set when the search is invoked from a Cmd+click on the spatial canvas so the
   * result lands where the user clicked.
   */
  createPosition?: { x: number; y: number } | null;
}

interface GlobalEntitySearchStore {
  isOpen: boolean;
  createPosition: { x: number; y: number } | null;
  open: (options?: OpenOptions) => void;
  close: () => void;
  toggle: () => void;
}

export const useGlobalEntitySearchStore = create<GlobalEntitySearchStore>((set) => ({
  isOpen: false,
  createPosition: null,
  open: (options) => set({ isOpen: true, createPosition: options?.createPosition ?? null }),
  close: () => set({ isOpen: false, createPosition: null }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen, createPosition: s.isOpen ? null : s.createPosition })),
}));
